import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  supplierList: [],
  globalEnabledSuppliers: [],
};

export const supplierSettingsSlice = createSlice({
  name: "supplierSettings",
  initialState,
  reducers: {
    setSupplierList: (state, action) => {
      state.supplierList = action.payload || [];
    },
    setGlobalEnabledSuppliers: (state, action) => {
      state.globalEnabledSuppliers = action.payload || [];
    },
  },
});

export const { setSupplierList, setGlobalEnabledSuppliers } =
  supplierSettingsSlice.actions;

export default supplierSettingsSlice.reducer;
